// import { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import SweetAlert from '../../Shared/Notification';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader';
// import CommonTable from '../../Shared/Tables/index';
// import { Button, Col, Row } from 'react-bootstrap';
// import SearchBox from '../../Shared/SearchBox';
// import ReactPagination from '../../Shared/Pagination';
// import DataNotFound from '../../Shared/DataNotFound';
// import LoadingWrapper from '../../Shared/LoadingWrapper';
// import ConfirmBox from '../../Shared/Notification/ConfirmBox';

// const SupplierTypeList = () => {
//   const navigate = useNavigate();

//   const [supplierList, setSupplierList] = useState([]);
//   const [filters, setFilters] = useState({ search: '', page: 0, totalCount: 0 });
//   const [isLoading, setIsLoading] = useState(false);

//   const getSupplierTypeList = async (data) => {
//     setIsLoading(true);
//     let res = await APIService.get(
//       `/v0/ui/dynamic-suppliers/supplier-type/?search=${data?.search}&next_page=${data?.page + 1}`
//     );
//     if (res.status == 200) {
//       setSupplierList(Object.values(res?.data?.list));
//       setFilters({ ...filters, page: data?.page, totalCount: res?.data?.count });
//     }
//     setIsLoading(false);
//   };
//   const onRemove = async (id, index) => {
//     const confirmed = await ConfirmBox({
//       title: 'Confirm Deletion',
//       text: 'Are you sure you want to delete this supplier type?',
//       icon: 'warning',
//     });
//     if (confirmed) {
//       let res = await APIService.remove(`/v0/ui/dynamic-suppliers/supplier-type/${id}/`);
//       if (res.status == 200) {
//         let data = supplierList;
//         data.splice(index, 1);
//         setSupplierList([...data]);
//         SweetAlert('Supplier Type deleted successfully', 'success');
//       }
//     }
//   };
//   const onSearchFilterChange = (e) => {
//     getSupplierTypeList({ ...filters, search: e });
//   };
//   const onPageChange = (e) => {
//     getSupplierTypeList({ ...filters, page: e?.selected });
//   };

//   useEffect(() => {
//     getSupplierTypeList(filters);
//   }, []);

//   const columns = [
//     {
//       dataField: 'id',
//       text: 'S.No.',
//       formatter: (cell, row, rowIndex) => rowIndex + 1,
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'name',
//       text: 'Name',
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'action',
//       text: 'Action',
//       headerAlign: 'center',
//       align: 'center',

//       formatter: (cell, row, rowIndex) => {
//         return (
//           <>
//             <Link to={`/r/supplier/type/edit/${row.id}`} className="btn btn--danger">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   fill="currentColor"
//                   className="bi bi-pencil-fill"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
//                 </svg>
//               </span>
//             </Link>
//             <span style={{ cursor: 'pointer' }} onClick={(e) => onRemove(row?.id, rowIndex)}>
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="16"
//                 height="16"
//                 fill="currentColor"
//                 className="bi bi-trash-fill"
//                 viewBox="0 0 16 16"
//               >
//                 <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
//               </svg>
//             </span>
//           </>
//         );
//       },
//     },
//   ];

//   return (
//     <>
//       <TableHeader headerValue={'Supplier Template'} />
//       <Row>
//         <Col xs="3" className="pb-2">
//           <SearchBox onSearch={onSearchFilterChange} value={filters?.search} />
//         </Col>{' '}
//         <Col xs="3" className="pb-2">
//           <Button
//             onClick={() => {
//               navigate('/r/supplier/type/create');
//             }}
//           >
//             Create Supplier Type
//           </Button>
//         </Col>{' '}
//       </Row>
//       {isLoading ? (
//         <LoadingWrapper />
//       ) : supplierList?.length > 0 ? (
//         <>
//           <CommonTable id={'id'} columnsData={columns} rowData={supplierList} />
//           <ReactPagination
//             pageNo={filters?.page}
//             pageSize={20}
//             totalItems={filters?.totalCount}
//             onPageChange={onPageChange}
//           />
//         </>
//       ) : (
//         <DataNotFound message="No Supplier types available. Create your first one now!" />
//       )}
//     </>
//   );
// };
// export default SupplierTypeList;

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import useDebounce from '../../Shared/Delay/index.tsx';

const SupplierTypeList = () => {
  const navigate = useNavigate();

  const [supplierList, setSupplierList] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    page: 0,
    limit: 20,
    totalCount: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackBar } = useSnackBar();
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [pendingDelete, setPendingDelete] = React.useState(null); // { id, index }
  const debouncedSearch = useDebounce(filters.search, 500);

  const getSupplierTypeList = async (data) => {
    console.log('filters:', filters);
    setIsLoading(true);
    let res = await APIService.get(
      `/v0/ui/dynamic-suppliers/supplier-type/?search=${data?.search}&next_page=${data?.page + 1}&pageSize=${data?.limit}`
    );
    if (res.status == 200) {
      setSupplierList(Object.values(res?.data?.list));
      setFilters({ ...filters, page: data?.page, totalCount: res?.data?.count });
    }
    setIsLoading(false);
  };

  const onRemove = (id, index) => {
    setPendingDelete({ id, index });
    setConfirmDialogOpen(true);
  };

  const handleConfirmClose = async (confirmed) => {
    setConfirmDialogOpen(false);

    if (confirmed && pendingDelete) {
      const { id, index } = pendingDelete;
      try {
        const res = await APIService.remove(`/v0/ui/dynamic-suppliers/supplier-type/${id}/`);
        if (res.status === 200) {
          const updatedList = [...supplierList];
          updatedList.splice(index, 1);
          setSupplierList(updatedList);
          showSnackBar('Supplier Type deleted successfully', 'success');
        }
      } catch (error) {
        showSnackBar('Failed to delete supplier type', 'error');
      }
    }

    setPendingDelete(null);
  };

  const onSearchFilterChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
      page: 0,
    }));
  };

  useEffect(() => {
    getSupplierTypeList({ ...filters, search: debouncedSearch });
  }, [debouncedSearch]);

  const columns = [
    {
      accessorKey: 'serial',
      header: 'S.No.',
      Cell: ({ row }) => row.index + 1,
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      Cell: ({ row }) => {
        const rowData = row.original;
        return (
          <Box display="flex" justifyContent="center" gap={1}>
            <Link to={`/r/supplier/type/edit/${rowData.id}`}>
              <IconButton size="small" color="primary">
                <EditIcon fontSize="small" />
              </IconButton>
            </Link>
            <IconButton size="small" onClick={() => onRemove(rowData.id, row.index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleChangePage = (event, newPage) => {
    getSupplierTypeList({ ...filters, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setFilters({ ...filters, limit: newLimit, page: 0 });
    getSupplierTypeList({ ...filters, limit: newLimit, page: 0 });
  };

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '5px' }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            Supplier Template
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ alignItems: 'center', pt: 2, pb: 2.5, gap: 2 }}>
        <Grid item xs={12} sm={6} md={2}>
          <SearchBox handleSearch={onSearchFilterChange} value={filters?.search} />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              navigate('/r/supplier/type/create');
            }}
          >
            Create Supplier Type
          </Button>
        </Grid>
      </Grid>
      <CommonTable
        columns={columns}
        data={supplierList}
        isLoading={isLoading}
        renderBottomToolbar={() => (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0 }}>
            <Pagination
              totalCount={filters?.totalCount}
              rowsPerPage={filters?.limit}
              page={filters?.page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Box>
        )}
      />
      <ConfirmBox
        open={confirmDialogOpen}
        onClose={handleConfirmClose}
        options={{
          title: 'Confirm Deletion',
          text: 'Are you sure you want to delete this supplier type?',
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          confirmButtonColor: 'error',
          cancelButtonColor: 'primary',
        }}
      />
    </Box>
  );
};
export default SupplierTypeList;
